import React from "react";
import { CButton, CCol, CRow } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import { decreaseStep, increaseStep } from "../../../modules/main";
import { useHistory, useLocation } from "react-router-dom";
import { persistor } from "src/store";
import { setIsFirstTrue } from "../../../modules/sbmsDoc";

const TheFooter = (props) => {
  const { insert } = useSelector((state) => state);
  const { stCd } = insert.reqTaskInfo;
  const propsData = { ...props };
  const dispatch = useDispatch();
  const history = useHistory();
  const corpNm = useLocation().pathname.split('/')[1];
  const pathParam = Number(useLocation().pathname.split('/')[2]);
  const buttonText =
    pathParam === 7 ? "제출" : pathParam === 2 ? "본인인증" : "임시저장";

  const handlePrevPage = async () => {
    if (pathParam === 6) {
      await dispatch(setIsFirstTrue());
    }
    await dispatch(decreaseStep());

    // if (pathParam === 4 || (cntrYn === "0" && pathParam === 5)) {
    //   history.push(`/${corpNm}/3?reqNo=${propsData.reqNo}&corpNo=${propsData.corpNo}&taskNo=${propsData.taskNo}`)
    // } else {
    //   history.goBack();
    // }
    history.goBack();
  };

  const handleNextPage = async (e) => {
    await dispatch(increaseStep());
    if (stCd === "10" || stCd === "99") {
      if (pathParam < 3) {
        history.push(`/${corpNm}/${pathParam + 1}`);
      } else {
        if (pathParam === 6) {
          props.handleUpload(e, true);
        } else if (pathParam === 5) {
          props.handleHdwtForApoDocSave(e, true);
        } else if (pathParam === 4) {
          props.handleHdwtForApoCntrSave(e, true);
        } else if (pathParam === 3) {
          props.handleFillInInfo(e, true);
        }
      }
    } else {
      if (pathParam === 6) {
        dispatch(setIsFirstTrue());
      }
      if (pathParam === 3 && propsData.cntrYn === "0") {
        history.push(`/${corpNm}/${pathParam + 2}`);
      } else {
        history.push(`/${corpNm}/${pathParam + 1}`);
      }
    }
  };

  const handleGoBackMain = () => {
    persistor.purge();
    history.push(`/${corpNm}`);
  };

  const handleSubmission = () => {
    props.handleSubmission();
  };

  const handleSelfCrtf = async () => {
    await dispatch(increaseStep());
    props.handleCheckAgree();
  };

  const handleTempSave = (e) => {
    if (pathParam === 6) {
      props.handleUpload(e, false);
    } else if (pathParam === 5) {
      props.handleHdwtForApoDocSave(e, false);
    } else if (pathParam === 4) {
      props.handleHdwtForApoCntrSave(e, false);
    } else if (pathParam === 3) {
      props.handleFillInInfo(e, false);
    }
  };

  return (
    <>
      <footer className="mainFooter layout-footer">
        { pathParam !== 1 && pathParam !== 3 
        && (
            <button className="btn-footer" type="button" onClick={handlePrevPage}>
            뒤로
            </button>
          )
        }
        { pathParam === 1 
        ? (<></>)
        : pathParam === 2 
        ? (
          <button className="btn-footer" type="button" onClick={handleSelfCrtf}>
            {buttonText}
          </button>
        )
        : pathParam === 7 
        ? (
            <button className="btn-footer" type="button"
              onClick={
                stCd === "20" ||stCd === "30" || stCd === "40"
                ? handleGoBackMain
                : handleSubmission
              }
            >
              {stCd === "20" || stCd === "30" || stCd === "40" ? "처음으로" : buttonText}
            </button>
          )
        : (
            stCd === "10" || stCd === "99") && (
            <button className="btn-footer" type="button" onClick={handleTempSave}>
              {buttonText}
            </button>
          )
        }
        { pathParam !== 2 && pathParam !== 7
        && (
            <button className="btn-footer" type="button" onClick={handleNextPage}>
              확인
            </button>
          )
        }
      </footer>
      {/* <footer className="mainFooter">
        <CRow className="footRow">
          <CCol xs="2"></CCol>
          <CCol xs="2">
            {pathParam !== 1 && pathParam !== 3 && (
              <CButton variant="outline" color="info" onClick={handlePrevPage}>
                ◁
              </CButton>
            )}
          </CCol>
          <CCol xs="4">
            {pathParam === 2 && (
              <CButton color="info" onClick={handleSelfCrtf}>
                {buttonText}
              </CButton>
            )}
            {pathParam === 7 && (
              <CButton
                color="info"
                onClick={
                  stCd === "20" || stCd === "30" || stCd === "40"
                    ? handleGoBackMain
                    : handleSubmission
                }
              >
                {stCd === "20" || stCd === "30" || stCd === "40"
                  ? "메인화면"
                  : buttonText}
              </CButton>
            )}
            {(pathParam === 3 ||
              pathParam === 4 ||
              pathParam === 5 ||
              pathParam === 6) &&
              (stCd === "10" || stCd === "99") && (
                <CButton color="info" onClick={handleTempSave}>
                  {buttonText}
                </CButton>
              )}
          </CCol>
          <CCol xs="2">
            {pathParam !== 2 && pathParam !== 7 && (
              <CButton variant="outline" color="info" onClick={handleNextPage}>
                ▷
              </CButton>
            )}
          </CCol>
          <CCol xs="2"></CCol>
        </CRow>
      </footer> */}
    </>
  );
};

export default TheFooter;
